"use client";

import type React from "react";
import { useSecurityCheck } from "../hooks/useSecurityCheck";

export const SecurityWarning: React.FC = () => {
  const { isInIframe, securityWarnings } = useSecurityCheck();

  if (!isInIframe && securityWarnings.length === 0) return null;

  // 🔧 Dynamic URL based on environment AND platform
  const hostname = window.location.hostname;
  let safeUrl = "https://codechatura.com"; // Default production

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    safeUrl = "http://localhost:3001";
  } else if (hostname.includes("hackathon.localhost")) {
    safeUrl = "http://hackathon.localhost:3001";
  } else if (hostname.includes("chaturvyuha")) {
    safeUrl = "https://chaturvyuha.codechatura.com";
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: "#d32f2f",
        color: "white",
        padding: "16px",
        zIndex: 9999,
        textAlign: "center",
        fontSize: "14px",
        fontWeight: "bold",
      }}
    >
      <div>
        ⚠️ SECURITY WARNING: This page appears to be embedded in another
        website.
        <br />
        For your security, please visit{" "}
        <a
          href={safeUrl}
          style={{ color: "white", textDecoration: "underline" }}
          target="_top"
        >
          {safeUrl}
        </a>{" "}
        directly.
        <br />
        <button
          onClick={() => (window.top!.location.href = safeUrl)}
          style={{
            backgroundColor: "white",
            color: "#d32f2f",
            border: "none",
            padding: "8px 16px",
            marginTop: "8px",
            borderRadius: "4px",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          Go to Safe Site
        </button>
      </div>
    </div>
  );
};